export const isMobile=()=>{
if(window.innerWidth>=1200){
    return false
}
return true
}